// src/pages/Login.js

import React, { useState } from 'react';
import { login } from '../services/auth';
import { requestPasswordReset } from '../services/auth';
import { useNavigate } from 'react-router-dom';
import PasswordInput from '../components/PasswordInput';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import './Login.css';
import { PageLoadingOverlay } from '../components/GoldfishLoader';

const Login = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [error, setError] = useState(null);
    const [forgotVisible, setForgotVisible] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetMsg, setResetMsg] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [loading, setLoading] = useState(false);    const navigate = useNavigate();

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const response = await login(credentials);

            // keep loading on until navigation happens to avoid flicker
            if (response.password_change_required) {
                navigate('/password-change', {
                    state: { userid: response.id },
                });
            } else {
                navigate('/home');
            }
        } catch (err) {
            setError(err.response?.data?.detail || 'Invalid username or password');
            setLoading(false);
        }
    };

    const sendResetLink = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(resetEmail)) {
            setEmailError('Please enter a valid email address.');
            return;
        }

        try {
            await requestPasswordReset(resetEmail);
            setResetMsg('If that email is registered, you will receive a reset link.');
            setEmailError(null);
        } catch {
            setResetMsg('If that email is registered, you will receive a reset link.');
            setEmailError(null);
        }
    };

    return (
        <>
        <form onSubmit={handleSubmit} aria-busy={loading}>
            <div className={`login-container ${loading ? 'blurred' : ''}`}>
                <div className="login-box" aria-hidden={loading}>
                    <img src="/logo.png" alt="Goldfish Logo" className="login-logo" />
                    <h2 className="login-title">Start Fishing.!</h2>
                    <input
                        name="username"
                        type="text"
                        value={credentials.username}
                        onChange={handleChange}
                        placeholder="Username"
                        className="login-input"
                        required
                        disabled={loading}
                    />
                    <PasswordInput
                        name="password"
                        autoComplete="on"
                        value={credentials.password}
                        onChange={handleChange}
                        placeholder="Password"
                        className="login-input"
                        required
                        disabled={loading}
                    />
                    <p
                        className="forgot-link"
                        onClick={() => {
                            if (loading) return;
                            setResetMsg(null);
                            setForgotVisible(true);
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        Forgot password?
                    </p>
                    <p className="error">{error || '\u00A0'}</p>
                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? 'Signing in...' : 'Login'}
                    </button>
                </div>
            </div>
        </form>

        {loading && <PageLoadingOverlay message="Signing in…" />}

            {/* Forgot Password Dialog */}
            <Dialog
                header="Reset Your Password"
                visible={forgotVisible}
                style={{ width: '400px', borderRadius: '12px' }}
                modal
                onHide={() => setForgotVisible(false)}
                className="forgot-dialog"
            >
                <div className="p-fluid">
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="resetEmail" style={{ fontWeight: 'bold' }}>Registered Email</label>
                        <InputText
                            id="resetEmail"
                            type="email"
                            value={resetEmail}
                            onChange={(e) => {
                                setResetEmail(e.target.value);
                                setEmailError(null);
                            }}
                            placeholder="you@example.com"
                            style={{ borderRadius: '8px' }}
                        />
                        {emailError && <small className="p-error">{emailError}</small>}
                    </div>
                    <Button
                        label="Send Reset Link"
                        icon="pi pi-send"
                        onClick={sendResetLink}
                        className="p-button-secondary"
                        style={{ width: '100%', borderRadius: '8px' }}
                    />
                    {resetMsg && (
                        <p style={{
                            marginTop: '1rem',
                            color: '#0f5132',
                            backgroundColor: '#d1e7dd',
                            padding: '0.5rem',
                            borderRadius: '6px',
                            fontSize: '0.9em'
                        }}>
                            {resetMsg}
                        </p>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default Login;